import { render, staticRenderFns } from "./VerifyEmailUI.vue?vue&type=template&id=6d629bc0&scoped=true"
import script from "./VerifyEmailUI.vue?vue&type=script&lang=js"
export * from "./VerifyEmailUI.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailUI.vue?vue&type=style&index=0&id=6d629bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d629bc0",
  null
  
)

export default component.exports